import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';

import AbstractHover from './abstractHover';

class HoverZone extends AbstractHover {
    bookedCapacities(zone) {
        return zone.categories.reduce((acc, current) => acc + current.booked, 0);
    }

    totalCapacities(zone) {
        return zone.categories.reduce((acc, current) => acc + current.all, 0);
    }

    renderCapacities(zone) {
        let booked = this.bookedCapacities(zone);
        let total = this.totalCapacities(zone);
        let rate = total === 0 ? 0 : (booked / total).toFixed(2) * 100;

        // Formatting
        rate = rate.toFixed(2);
        if (/.00$/.test(rate)) {
            rate = rate.split('.')[0];
        }

        const { t } = this.props;

        return (
            <div className="sales">
                <div className="data">
                    <span className="number">{booked}</span>
                    <span className="text">{t('ticket.common.sales', 'ventes')}</span>
                    <span className="number">/</span>
                    <span className="number">{total}</span>
                    <span className="text">{t('ticket.common.capacity', 'capacité')}</span>
                </div>
                <div className="rate">
                    <span className="number">{rate}%</span>
                    <span className="text">{t('ticket.common.filled', 'de remplissage')}</span>
                </div>
            </div>
        );
    }

    renderContingents() {
        return 'Not yet implemented';
    }

    renderCategory(category) {
        const { t } = this.props;
        return (
            <li key={category.uuid} className="category" data-id={category.uuid}>
                <div className="category-icon" style={{ backgroundColor: category.color }} />
                <div className="name">
                    {t('ticket.common.category', 'Catégorie')} {category.name}
                </div>
            </li>
        );
    }

    renderCategories(zone) {
        return <ul className="categories">{zone.categories.map(this.renderCategory.bind(this))}</ul>;
    }

    renderContent() {
        let { zone } = this.props;
        return (
            <div>
                <div className="block">{this.renderCapacities(zone)}</div>
                <div className="block">{this.renderCategories(zone)}</div>
            </div>
        );
    }
}

HoverZone.propTypes = {
    zone: PropTypes.object.isRequired
};

export default withTranslation()(HoverZone);
